import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Subscription } from "rxjs";
import { CourseDetail, CourseResponse } from "src/app/interfaces/response";
import { SectoresProductivosService } from "src/app/services/sectores-productivos.service";

@Component({
  selector: "app-renac-detalle-curso",
  templateUrl: "./renac-detalle-curso.component.html",
  styleUrls: ["./renac-detalle-curso.component.css"],
})
export class RenacDetalleCursoComponent implements OnInit {
  togle1: boolean = true;
  togle2: boolean = true;
  togle3: boolean = true;
  togle4: boolean = true;
  togle5: boolean = true;
  mostrarCursos: boolean = false;
  curso: CourseDetail;
  @Input() idCurso: number | null = null;
  @Input() course: CourseResponse | null = null;
  @Output() closeDetail = new EventEmitter<void>();
  private subscription: Subscription = new Subscription();

  constructor(private service: SectoresProductivosService) {}

  ngOnInit(): void {
    if (this.idCurso) {
      this.loadCourseDetail(this.idCurso);
    }
  }

  close() {
    this.closeDetail.emit();
  }


  loadCourseDetail(id: number): void {
    this.subscription.add(
      this.service.getDetalleCurso(id).subscribe({
        next: (data) => {
          this.curso = data;
          this.curso.modulos = this.curso.modulos
            .replace(/\n/g, "<br>")
        },
        error: (error) => {
          console.error("Error al obtener cursos:", error);
        },
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  collapseOpen(nombre: any, id: any) {
    var elemento = document.getElementById(nombre);
    var collapse1 = document.getElementById("collapse1");
    var collapse2 = document.getElementById("collapse2");
    var collapse4 = document.getElementById("collapse4");
    if (this.mostrarCursos)
      var collapse5 = document.getElementById("collapse5");
    switch (id) {
      case 1:
        if (this.togle1) {
          elemento.className = "panel-collapse collapse show";
          collapse2.className = "panel-collapse collapse hide";
          collapse4.className = "panel-collapse collapse hide";
          if (this.mostrarCursos)
            collapse5.className = "panel-collapse collapse hide";
          this.togle1 = false;
          this.togle2 = true;
          this.togle3 = true;
          this.togle4 = true;
          this.togle5 = true;
        } else {
          elemento.className = "panel-collapse collapse hide";
          this.togle1 = true;
        }
        break;
      case 2:
        if (this.togle2) {
          elemento.className = "panel-collapse collapse show";
          this.togle2 = false;
          this.togle1 = true;
          this.togle3 = true;
          this.togle4 = true;
          this.togle5 = true;
          collapse1.className = "panel-collapse collapse hide";
          collapse4.className = "panel-collapse collapse hide";
          if (this.mostrarCursos)
            collapse5.className = "panel-collapse collapse hide";
        } else {
          elemento.className = "panel-collapse collapse hide";
          this.togle2 = true;
        }
        break;

      case 3:
        if (this.togle3) {
          elemento.className = "panel-collapse collapse show";
          this.togle3 = false;
          this.togle1 = true;
          this.togle2 = true;
          this.togle4 = true;
          this.togle5 = true;
          collapse1.className = "panel-collapse collapse hide";
          collapse2.className = "panel-collapse collapse hide";
          collapse4.className = "panel-collapse collapse hide";
          if (this.mostrarCursos)
            collapse5.className = "panel-collapse collapse hide";
        } else {
          elemento.className = "panel-collapse collapse hide";
          this.togle3 = true;
        }
        break;
      case 4:
        if (this.togle4) {
          elemento.className = "panel-collapse collapse show";
          this.togle4 = false;
          this.togle1 = true;
          this.togle2 = true;
          this.togle3 = true;
          this.togle5 = true;
          collapse1.className = "panel-collapse collapse hide";
          collapse2.className = "panel-collapse collapse hide";
          if (this.mostrarCursos)
            collapse5.className = "panel-collapse collapse hide";
        } else {
          elemento.className = "panel-collapse collapse hide";
          this.togle4 = true;
        }
        break;
      case 5:
        if (this.togle5) {
          elemento.className = "panel-collapse collapse show";
          this.togle5 = false;
          this.togle1 = true;
          this.togle2 = true;
          this.togle3 = true;
          this.togle4 = true;
          collapse1.className = "panel-collapse collapse hide";
          collapse2.className = "panel-collapse collapse hide";
          collapse4.className = "panel-collapse collapse hide";
        } else {
          elemento.className = "panel-collapse collapse hide";
          this.togle5 = true;
        }
        break;
    }
  }
}
